import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Field, TagSelector } from '@dossierhq/design';
export function TypeTagSelector({ state, dispatch }) {
    if (state.selectedIds.length === 0) {
        return null;
    }
    return (_jsxs(Field, { children: [_jsx(Field.Label, { size: "small", children: "Show types" }), _jsx(Field.Control, { children: _jsx(TagSelector, { clearLabel: "Clear", itemTag: (item) => ({ tag: item.name }), state: state, dispatch: dispatch }) })] }));
}
//# sourceMappingURL=TypeTagSelector.js.map